module.exports = __webpack_public_path__ + "img/010.14f5be97.png";